function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemConfigurations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 19.647,
    viewBox: "0 0 19.453 19.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5084",
    d: "m21.643 11.064-1.178-.548c.023-.246.034-.472.034-.693s-.011-.447-.034-.693l1.178-.549a.576.576 0 0 0 .3-.7l-.711-2.19a.576.576 0 0 0-.658-.387l-1.271.248a8.275 8.275 0 0 0-.819-1.12l.635-1.132a.576.576 0 0 0-.165-.745L17.091 1.2a.576.576 0 0 0-.76.073l-.887.952a8.192 8.192 0 0 0-1.315-.425L13.971.506A.576.576 0 0 0 13.4 0h-2.3a.576.576 0 0 0-.571.506l-.16 1.294a8.187 8.187 0 0 0-1.316.429l-.887-.952a.576.576 0 0 0-.76-.073L5.543 2.553a.576.576 0 0 0-.165.745l.631 1.136a8.269 8.269 0 0 0-.819 1.12l-1.271-.248a.576.576 0 0 0-.658.387l-.711 2.19a.576.576 0 0 0 .3.7l1.178.549C4.01 9.377 4 9.6 4 9.823s.011.447.034.693l-1.178.548a.576.576 0 0 0-.3.7l.711 2.19a.576.576 0 0 0 .658.387l1.271-.248a8.272 8.272 0 0 0 .819 1.119l-.631 1.136a.576.576 0 0 0 .165.745l1.863 1.353a.576.576 0 0 0 .76-.073l.887-.952a8.192 8.192 0 0 0 1.316.429l.158 1.29a.576.576 0 0 0 .571.506h2.3a.576.576 0 0 0 .571-.506l.158-1.29a8.187 8.187 0 0 0 1.316-.429l.887.952a.576.576 0 0 0 .76.073l1.863-1.353a.576.576 0 0 0 .165-.745l-.631-1.136a8.269 8.269 0 0 0 .819-1.12l1.271.248a.576.576 0 0 0 .658-.387l.711-2.19a.576.576 0 0 0-.3-.7zm-9.394 4.323a5.564 5.564 0 1 1 5.564-5.564 5.57 5.57 0 0 1-5.564 5.564z",
    transform: "translate(-2.522)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemConfigurations);
export default __webpack_public_path__ + "static/media/system-configurations.5ca2f3e98966f9d4981d93f4a61528fb.svg";
export { ForwardRef as ReactComponent };